import { Button, CircularProgress } from "@mui/material";
import { useGetSessionQuery, useUnbookSessionMutation } from '../services/api';
import { useDispatch } from 'react-redux';
import { toast } from '../features/snackbar/snackbarSlice';

export function UnbookButton({
  guid,
  inSession,
}: {
  guid?: string;
  inSession: boolean;
}) {
  const [unbook, { isLoading }] = useUnbookSessionMutation();
  const { data: session } = useGetSessionQuery(guid);
  const dispatch = useDispatch();

  if (!session?.booked) {
    return null;
  }
  if (inSession) {
    return null;
  }
  return (
    <Button
      disabled={isLoading}
      fullWidth
      onClick={async () => {
        await unbook(session!.guid)
          .then(() => {
            dispatch(
              toast({
                message: 'Session Reservation Cancelled',
                severity: 'warning',
              })
            );
          });
      }}
      variant='contained'
    >{isLoading
      ? <CircularProgress
        size={25} />
      : 'Cancel Reservation'}</Button>
  );
}
